"use client";
import Link from "next/link";
import { courses as detailedCourses } from "@/lib/courses";
import OptimizedImage from "@/components/ui/OptimizedImage";

// Main courses
const courseCards = [
  { slug:"frontend-web-development", title:"Frontend Web Development", img:"/images/webdevelopmet.webp" },
  // { slug:"web3-crypto-trading", title:"Web3 & Crypto Trading", img:"/images/trading.webp" },
  { slug:"graphic-designing", title:"Graphic Designing", img:"/images/graphic.webp" },
  { slug:"video-editing", title:"Video Editing", img:"/images/videoediting.webp" },
  { slug:"digital-marketing", title:"Digital Marketing", img:"/images/digital-marketing.webp" },
].map(card => ({
  ...card,
  img: card.img,
  short: detailedCourses.find(c=>c.slug===card.slug)?.short || ''
}));

// Special winter courses
const winterCourses = [
  { slug:"graphic-video-basics", title:"Basics of Graphic Design & Video Editing", img:"/images/course-winter.avif" },
  { slug:"computer-basics-kids", title:"Computer Basics & Digital Confidence", img:"/images/winter-course.webp" },
].map(card => ({
  ...card,
  img: card.img,
  short: detailedCourses.find(c=>c.slug===card.slug)?.short || ''
}));

export default function CoursesShowcase(){
  return (
    <section id="courses" className="relative py-28 sm:py-18">
      {/* Background accents */}
      

      <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
        {/* <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[color-mix(in_srgb,var(--brand)_55%,var(--blue-border))] to-transparent" /> */}
        {/* <div className="absolute left-1/2 top-24 -translate-x-1/2 w-[72%] max-w-[950px] h-[520px] rounded-[48px] bg-[radial-gradient(circle_at_45%_30%,rgba(255,122,24,0.18),transparent_70%)] blur-2xl opacity-60" /> */}
      </div>
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        
       

        {/* Special Winter Courses Section */}
     

<div className="text-center max-w-3xl mx-auto my-20">
          <h2 className="text-3xl md:text-5xl font-semibold tracking-tight text-white">Explore Our Courses</h2>
          <span className="border-b  block border-white p-1"></span>
          <p className="mt-5 text-base md:text-lg text-white/70 leading-relaxed">Future‑proof your skillset with immersive, project‑driven learning paths guided by practitioners.</p>
        </div>

         {/* Main Courses Grid */}
        <div className="grid sm:grid-cols-2 gap-10">
          {courseCards.map(c => (
            <article key={c.slug} className="group relative h-56 sm:h-60 rounded-3xl overflow-hidden  bg-[var(--blue-surface)] shadow-[0_8px_30px_-10px_rgba(0,0,0,0.35)]">
              {/* Background image + gradient overlay */}
              <div className="absolute inset-0">
                <div className="absolute inset-0 bg-[linear-gradient(140deg,#203344,#101b26)]" />
                <OptimizedImage
                  src={c.img}
                  alt={c.title + " course"}
                  fill
                  sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw"
                  quality={80}
                  priority={false}
                  className="object-cover w-full h-full group-hover:opacity-65 group-hover:scale-[1.05] transition duration-700 ease-[cubic-bezier(.16,.84,.44,1)] will-change-transform"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/20 to-transparent" />
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_25%_30%,rgba(var(--brand-rgb),0.22),transparent_65%)] opacity-40 mix-blend-overlay" />
              </div>
              {/* Content */}
              <div className="relative z-10 flex flex-col h-full p-6">
                <h3 className="text-xl font-semibold tracking-tight text-white drop-shadow-[0_4px_14px_rgba(0,0,0,0.55)] pr-4">
                  {c.title}
                </h3>
                {/* {c.short && <p className="mt-2 text-[13px] leading-relaxed text-white/70 line-clamp-3 max-w-[90%]">{c.short}</p>} */}
                <div className="mt-auto pt-6 flex flex-wrap gap-3">
                  <Link href="/enroll" className="inline-flex items-center gap-2 rounded-full px-5 h-10 text-[12px] font-semibold text-white bg-brand-gradient hover:brightness-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand transition">
                    Enroll Now
                  </Link>
                  <Link href={`/courses/${c.slug}`} className="inline-flex items-center gap-2 rounded-full px-5 h-10 text-[12px] font-semibold text-white/90 bg-[rgba(255,255,255,0.08)] hover:bg-[rgba(255,255,255,0.15)] backdrop-blur-sm border border-white/30 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand transition">
                    See Details
                  </Link>
                </div>
              </div>
              {/* Focus ring helper */}
              <span className="pointer-events-none absolute inset-0 rounded-3xl ring-0 group-focus-within:ring-2 ring-brand/60 transition" />
            </article>
          ))}
        </div>
      </div>
       {/* <div className=" mt-10 h-px bg-gradient-to-r from-transparent via-[color-mix(in_srgb,var(--brand)_55%,var(--blue-border))] to-transparent" /> */}

    </section>
  );
}